import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { fadeAnimations } from 'src/app/shared/animations/fading.animation';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';
import { FundsPortalService } from 'src/app/core/services/funds-portal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, LocalStorageService } from 'src/app/core/core.module';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sign-up-v2',
  templateUrl: './sign-up-v2.component.html',
  styleUrls: ['./sign-up-v2.component.less'],
  animations: [fadeAnimations.default, fadeAnimations.down]
})
export class SignUpV2Component implements OnInit {

  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public searchFormGroup!: FormGroup;

  public openNav: boolean = false;
  public resendOTP: boolean = false;
  public countDown: number = 60;
  public countDownTracker: string = '';
  public emailCode: string = '';
  public isNotValidInputs: boolean = false;

  constructor(
    public fundsPortalService: FundsPortalService,
    public authService: AuthService,
    public router: Router,
    public route: ActivatedRoute,
    public localStorageService: LocalStorageService
  ) {
    this.route.queryParams.subscribe(params => {
      const rawCode = (params['code'] || '').toString();
      this.emailCode = rawCode.replace(/(\?code=|&code=).*/, '');
      if (this.localStorageService.get('email_code') == null || (this.emailCode != this.localStorageService.get('email_code'))) {
        this.localStorageService.set('email_code', this.emailCode, 9999);
      }
    });
  }

  ngOnInit(): void {
    if (this.localStorageService.get('bearer') !== null && this.localStorageService.isExpired('bearer')) {
      this.localStorageService.remove('bearer');
      this.localStorageService.remove('email');
      this.localStorageService.remove('mobile_number');
      this.localStorageService.remove('authorized');
    }
    this.initializeFormGroup();
    if (!environment.DEV_BYPASS_INVITE) {
      this.validateInviteCode();
    } else {
      const devId = Math.floor(Math.random() * 90000) + 10000;
      this.searchFormGroup.get('companyEmail')?.setValue(`dev-user-${devId}@test.com`);
      this.searchFormGroup.get('companyCode')?.setValue(`DEV${devId}`);
    }
  }

  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      companyEmail: new FormControl('', [Validators.required]),
      companyCode: new FormControl('', [Validators.required]),
      mobileNo: new FormControl('', [Validators.required]),
      word: new FormControl('', [Validators.required,
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,15}$')]),
      confirmWord: new FormControl('', [Validators.required,
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{12,15}$')])
    });
  }

  validateInviteCode(): Promise<any> {
    var body = {
      invite_code: this.localStorageService.get('email_code'),
    };

    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.validateInviteCode(body)
        .subscribe({
          next: (data: any) => {
            resolve(data);
            const responseData = data['response_data'] || {};
            const registrationSession = responseData['registration_session'] || {};
            if (registrationSession['is_mobile_number_verified'] === true) {
              this.router.navigateByUrl(``, { skipLocationChange: false });
            } else if (registrationSession['company_user'] !== null) {
              const companyUser = registrationSession['company_user'] || {};
              const resumeEmail =
                responseData['email'] ||
                companyUser['company_email'] ||
                companyUser['email'] ||
                this.localStorageService.get('setup_resume_email') ||
                this.localStorageService.get('email') ||
                this.searchFormGroup.get('companyEmail')?.value ||
                '';
              const resumeCompanyCode =
                responseData['company_code'] ||
                companyUser['company_code'] ||
                this.localStorageService.get('setup_resume_company_code') ||
                this.localStorageService.get('login_company_code') ||
                this.searchFormGroup.get('companyCode')?.value ||
                '';
              this.tryRefreshSetupChallenge(resumeEmail, resumeCompanyCode);
              return;
            } else if (registrationSession['mobile_number'] !== null) {
              this.router.navigateByUrl(`/sign-up/totp-enroll`, { skipLocationChange: false });
            } else if (registrationSession['company_user'] === null) {
              this.searchFormGroup.get('companyEmail')?.setValue(data['response_data']['email']);
              this.searchFormGroup.get('companyCode')?.setValue(data['response_data']['company_code']);
              return;
            }
          },
          error: error => {
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Validation Failed';
            this.atramModal.bodyText = 'Incorrect Email Code';
            this.atramModal.okButtonText = 'Return';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  this.router.navigateByUrl(``, { skipLocationChange: false });
                }
                this.atramModal.hide();
              });
          }
        });
    });
  }

  proceed(): void {
    var firstName = this.searchFormGroup.get('firstName');
    var lastName = this.searchFormGroup.get('lastName');
    var companyCode = this.searchFormGroup.get('companyCode');
    var companyEmail = this.searchFormGroup.get('companyEmail');
    var word = this.searchFormGroup.get('word');
    var confirmWord = this.searchFormGroup.get('confirmWord');

    if (!firstName?.valid ||
      !lastName?.valid ||
      !companyCode?.valid ||
      !companyEmail?.valid ||
      !word?.valid ||
      !confirmWord?.valid ||
      word.value != confirmWord.value) {
      this.isNotValidInputs = true;
      firstName?.markAsTouched();
      lastName?.markAsTouched();
      companyCode?.markAsTouched();
      companyEmail?.markAsTouched();
      word?.markAsTouched();
      confirmWord?.markAsTouched();
      return;
    } else {
      this.isNotValidInputs = false;
      this.localStorageService.set('plainPass', word?.value, 900);
      this.localStorageService.set('login_company_code', companyCode?.value, 900);
      this.localStorageService.set('setup_resume_email', companyEmail?.value, 86400);
      this.localStorageService.set('setup_resume_company_code', companyCode?.value, 86400);

      if (environment.DEV_BYPASS_INVITE) {
        this.router.navigateByUrl(`/sign-up/totp-enroll`, { skipLocationChange: false });
        return;
      }

      this.submit();
    }
  }

  submit(): Promise<any> {
    let body = {
      personal_info: {
        first_name: this.searchFormGroup.get('firstName')?.value,
        last_name: this.searchFormGroup.get('lastName')?.value,
        mobile_number: this.searchFormGroup.get('mobileNo')?.value,
        password: this.searchFormGroup.get('word')?.value,
      },
      company_info: {
        company_email: this.searchFormGroup.get('companyEmail')?.value,
        company_code: this.searchFormGroup.get('companyCode')?.value
      },
      invite_code: this.localStorageService.get('email_code')
    };

    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.postCompanyUser(body)
        .subscribe({
          next: (data: any) => {
            resolve(data);
            if (data['response_result'] === '0001') {
              if (this.localStorageService.get('isReverify') !== null) {
                this.localStorageService.remove('isReverify');
              }
              this.localStorageService.set('isReverify', '1');
              this.router.navigateByUrl(`/sign-up/totp-enroll`, { skipLocationChange: false });
              return;
            } else {
              this.atramModal.show();
              this.atramModal.size = 'sm';
              this.atramModal.status = 'error';
              this.atramModal.headerText = 'Registration Failed';
              this.atramModal.bodyText = 'E-mail already registered.';
              this.atramModal.okButtonText = 'Go To Sign-in';
              this.atramModal.showCancelButton = false;
              this.atramModal.showCloseButton = false;
              this.atramModal.confirmationSubject
                .subscribe((confirmation: boolean) => {
                  if (confirmation) {
                    this.router.navigateByUrl(``, { skipLocationChange: false });
                  }
                  this.atramModal.hide();
                });
              return;
            }
          },
          error: error => {
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'error';
            this.atramModal.headerText = 'Registration Failed';
            this.atramModal.bodyText = 'E-mail already registered.';
            this.atramModal.okButtonText = 'Go To Sign-in';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  this.router.navigateByUrl(``, { skipLocationChange: false });
                }
                this.atramModal.hide();
              });
            return;
          }
        });
    });
  }

  goToSignIn() {
    this.router.navigateByUrl(``, { skipLocationChange: false });
  }

  private tryRefreshSetupChallenge(email: string, companyCode: string): void {
    const password = this.localStorageService.get('plainPass');

    if (!email || !companyCode || !password) {
      this.localStorageService.set('enroll_context', 'login', 900);
      this.router.navigateByUrl(`/sign-up/email-otp-verify`, { skipLocationChange: false });
      return;
    }

    const loginBody = {
      email: email,
      company_code: companyCode,
      password: password
    };

    this.authService.postLogin(loginBody).subscribe({
      next: (loginData: any) => {
        const token = loginData?.response_data?.token;
        if (token?.access_token) {
          this.localStorageService.set('bearer', token.access_token, token.expires_in);
          this.localStorageService.set('email', email, token.expires_in);
          this.localStorageService.set('login_company_code', companyCode, token.expires_in);
          this.localStorageService.set('mobileNo', token.mobile_number, token.expires_in);
          this.localStorageService.set('enroll_context', 'login', token.expires_in);
        } else {
          this.localStorageService.set('enroll_context', 'login', 900);
        }
        this.router.navigateByUrl(`/sign-up/email-otp-verify`, { skipLocationChange: false });
      },
      error: () => {
        this.localStorageService.set('enroll_context', 'login', 900);
        this.router.navigateByUrl(`/sign-up/email-otp-verify`, { skipLocationChange: false });
      }
    });
  }
}
